<template>
    <span v-if="mostrarBtnAprovar">
        <b-button
            variant="primary"
            @click.stop="abrirDetalheReprovacao()"
            class="ml-2"
        >
            <span> <i class="fa fa-check-circle"></i> Aprovar com justificativa</span>
        </b-button>
        <b-modal
            id="modalJustificativaAprovacao"
            v-model="mostrarModalDetalheAprovacaoJustificada"
        >
            <div slot="modal-title">
                Registro de Pagamento - Detalhe da aprovação justificada
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">
                            Justificativa da aprovação
                        </label>
                        <b-form-select
                            :options="categoriasAprovacaoJustificada"
                            v-model="categoriaAprovacaoJustificadaId"
                            text-field="descricao"
                            value-field="id"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="insereDetalheAprovacaoJustificada">
                    <b-form-group>
                        <label>Detalhe da aprovacão</label>
                        <b-form-textarea
                            v-model="detalheAprovacaoJustificada"
                            :rows="4"
                            @input="$v.detalheAprovacaoJustificada.$touch()"
                            :state="$v.detalheAprovacaoJustificada.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >O detalhe é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">
                            Gestor
                        </label>
                        <b-form-select
                            :options="funcionarios"
                            v-model="emailGestor"
                            text-field="nome"
                            value-field="email"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharDetalheReprovacao()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAprovar()"
                    class="ml-2"
                >
                    <span> <i class="fa fa-check-circle"></i> Aprovar </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { pagamentoStatus } from './PagamentoStatus'
import { perfil } from '../../SgtecPerfis'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModalDetalheAprovacaoJustificada: false,
            detalheAprovacaoJustificada: '',
            categoriasAprovacaoJustificada: [],
            categoriaAprovacaoJustificadaId: null,
            categoriasDetalheId: [],
            categoriaFMOId: null,
            emailGestor: '',
            funcionarios: []
        }
    },

    methods: {
        abrirDetalheReprovacao() {
            this.mostrarModalDetalheAprovacaoJustificada = true
        },

        fecharDetalheReprovacao() {
            this.mostrarModalDetalheAprovacaoJustificada = false
            this.detalheAprovacaoJustificada = ''
        },

        confirmarAprovar() {
            this.$swal({
                title: `Aprovar Registro de Pagamento`,
                html: `Confirma a aprovação justificada do registro de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.aprovar()
                }
            })
        },

        aprovar() {
            this.$store.dispatch('addRequest')
            let aprovaComJustificativaPagamentoDto = {
                pagamentoId: this.$route.params.pagamentoId,
                detalheAprovacaoJustificada: this.insereDetalheAprovacaoJustificada ? this.detalheAprovacaoJustificada : null,
                categoriaAprovacaoJustificadaId: this.categoriaAprovacaoJustificadaId,
                emailGestor: this.emailGestor,
                perfil: perfil.UABS,
                acao: 'A'
            }
            this.pagamentosServicos
                .aprovarReprovarPagamento(aprovaComJustificativaPagamentoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                            this.fecharDetalheReprovacao()
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar registro de pagamento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        obterCategoriasAprovacaoJustificada() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.obterCategoriasAprovacaoJustificada()
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.categoriasAprovacaoJustificada = response.data.categoriasAprovacaoJustificada
                            this.categoriasDetalheId = response.data.categoriasDetalheId
                            this.categoriaFMOId = response.data.categoriaFMOId
                            this.funcionarios = response.data.funcionarios
                        } else {
                            this.error = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnAprovar() {
            return (
                (this.$temAcesso('SGTEC-UABS-PAG-02') &&
                    (this.pagamento.status === pagamentoStatus.EM_ANALISE ||
                        this.pagamento.status ===
                            pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO))
            )
        },

        insereDetalheAprovacaoJustificada() {
            if (this.categoriaAprovacaoJustificadaId == null) {
                return false
            }

            if (this.categoriasDetalheId.length == 0) {
                return false
            }
            
            if (!this.categoriasDetalheId.includes(this.categoriaAprovacaoJustificadaId)) {
                return false
            }

            return true
        },
    },

    validations: {
        detalheAprovacaoJustificada: {
            obrigatorio() {
                if (this.insereDetalheAprovacaoJustificada && (this.detalheAprovacaoJustificada == null || this.detalheAprovacaoJustificada == '')) {
                    return false
                }
                return true
            }
        },
        emailGestor: {
            required
        },
        categoriaAprovacaoJustificadaId: {
            required
        }
    },

    watch: {
        mostrarModalDetalheAprovacaoJustificada() {
            if (this.mostrarModalDetalheAprovacaoJustificada) {
                this.obterCategoriasAprovacaoJustificada()
            } 
        }
    }
}
</script>
